import * as React from 'react';
import { BrowserRouter, Route, Routes,Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Home';
import Counter from './components/Counter';
import FetchData from './components/FetchData';
import Error from './components/Error';
import Preview from './components/Preview';
import { getContextDetails } from './services/appservice';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.min.js';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import './custom.css'
import { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay-ts';
import '../node_modules/react-notifications/lib/notifications.css';
import { Constants } from './Constants';
import { useSelector, useDispatch, connect } from 'react-redux';
import { ApplicationState } from './store';
import * as AppStore from './store/AppDataContainer';
import LoadDynamicIndexHead from './LoadDynamicIndexHead';
import CustomLoader from './components/CustomLoader/CustomLoader';

//export default () => (
//    <Layout>
//        <Route exact path='/' component={Home} />
//        <Route path='/counter' component={Counter} />
//        <Route path='/fetch-data/:startDateIndex?' component={FetchData} />
//        <Route path='/preview' component={Preview} />
//        <Switch>
//            <Route exact path='/:experienceapp' component={Preview} />
//            <Route exact path='/:experienceapp/:experience' component={Preview} />
//            <Route exact path='/:experienceapp/:experience/:sitelet' component={Preview} />
//            <Route exact path='/:experienceapp/:experience/:sitelet/:page' component={Preview} />
//            <Route component={Home} />
//        </Switch>
//    </Layout>
//);

const App = () => {
    const [isValid, setIsValid] = useState(false);
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const appState = useSelector(state => state) as ApplicationState;
    const dispatch = useDispatch();

    const renderHtml = () => {
        return (
            isValid ?
                <Layout>
                    {
                        appState?.appStore?.QueryStringParams?.indexHead?.isDynamicHead &&  <LoadDynamicIndexHead appState={appState}/>
                    }
                    <BrowserRouter>
                    <Routes>
                    <Route  path='/' element={<Navigate to={'/exp/pw/pd'}/>} />
                            {/* <Route  path='/' element = { ()=>{
                        navigate('/exp/pw/pd')
                    } }/> */}
                    {/* <Route path='/counter' element={<Counter />} /> */}
                    <Route path='/fetch-data/:startDateIndex?' element={<FetchData />} />
                    <Route path='/preview' element={<Preview />} />
                        <Route  path='/:experienceapp' element={<Preview />} />
                        <Route  path='/:experienceapp/:experience' element={<Preview />} />
                        <Route  path='/:experienceapp/:experience/:sitelet' element={<Preview />} />
                        <Route  path='/:experienceapp/:experience/:sitelet/:page' element={<Preview />} />
                        <Route element={<Home />} />
                    </Routes>
                    </BrowserRouter>
                </Layout>
                :
                <CustomLoader />
                // <LoadingOverlay
                //     active={!isPageLoaded}
                //     spinner
                //     text='Page Loading ......'
                // >
                //     {isPageLoaded ? 
                //         <div></div>
                //      : <div></div>}
                // </LoadingOverlay>
        );
    }

    const getUserDetailsHandler = (data: any) => {
        if (data.data) {
            const cookies = new Cookies();
            if (data.data[0].isAuthenticated && data.data[0].isAuthorized) {
                cookies.set("LoginId", data.data[0].userName);
                setIsValid(true);
            }
            else {
                setIsValid(false);
            }
        }
        setIsPageLoaded(true);
    }

    const getContextDataHandler = (data: any) => {
        if (data.data) {
            dispatch(AppStore.layoutActionCreators.setContextData({}, data.data[0].contextData) as any);
        }
        setIsValid(true);
        setIsPageLoaded(true);
    }

    useEffect(() => {
        let path = window.location.pathname.substring(1);
        if (!isPageLoaded) {
            getContextDetails(getContextDataHandler);
        }        
        //let findIndex = Constants.NoAuthentication.findIndex(t => t.path.toLowerCase() === path.toLowerCase());
        //if (findIndex > -1) {
        //    document.title = Constants.NoAuthentication[findIndex].title;
        //    setIsValid(true);
        //}
        //else if (!isValid && !isPageLoaded) {
        //    getUserDetails(getUserDetailsHandler);
        //}
        //setIsValid(true);
        setIsPageLoaded(true);
    }, [appState, dispatch]);

    return renderHtml();
}
//export default App;

export default connect((state: ApplicationState) => state.appStore,
    AppStore.layoutActionCreators
)(App);